<template>
	<table class="table table-sm">
		<thead>
			<tr>
				<th colspan="3"></th>
				<th class="text-right">Estimated Hrs</th>
				<th class="text-right">Hrs to Date</th>
				<th class="text-right">Estimated Cost</th>
				<th class="text-right">Actual Cost</th>
				<th>% Complete</th>
				<th class="text-right">Over/Under</th>
			</tr>
		</thead>
		<tbody>
			<template v-for="group in reportLocal">
				<tr class="charge-out-group-row">
					<td colspan="2">{{ group.label }}</td>
					<td><i class="fa icon-button" :class="group.classificationsVisible ? 'fa-caret-down' : 'fa-caret-right'" v-on:click="group.classificationsVisible = !group.classificationsVisible"></i></td>
					<td class="text-right">{{ group.estimatedHrs.toFixed(2) }}</td>
					<td class="text-right">{{ group.hrsToDateTotal.toFixed(2) }}</td>
					<td class="text-right">{{ group.estimatedCost ? group.estimatedCost.toCurrency() : '' }}</td>
					<td class="text-right">{{ group.actualCost ? group.actualCost.toCurrency() : '' }}</td>
					<td v-html="stripInlineEventHandlers(renderInlineProgressBar(group.percentComplete))" class="text-center"></td>
					<td class="text-right" :class="{'text-danger' : group.overUnder < 0, 'text-success' : group.overUnder > 0}">{{ group.overUnder.toCurrency() }}</td>
				</tr>
				<template v-if="group.classificationsVisible" v-for="cl in group.classifications">
					<tr class="classification-row">
						<td><!-- Empty --></td>
						<td>{{ cl.title }}</td>
						<td></td>
						<td class="text-right">{{ cl.estimatedHrs ? cl.estimatedHrs.toFixed(2) : '' }}</td>
						<td class="text-right">{{ cl.hrsToDateTotal.toFixed(2) }}</td>
						<td class="text-right">{{ cl.estimatedCost ? cl.estimatedCost.toCurrency() : '' }}</td>
						<td class="text-right">{{ cl.actualCost ? cl.actualCost.toCurrency() : '' }}</td>
						<td v-html="stripInlineEventHandlers(cl.percentComplete ? renderInlineProgressBar(cl.percentComplete) : '')" class="text-center"></td>
						<td class="text-right" :class="{'text-danger' : cl.overUnder < 0, 'text-success' : cl.overUnder > 0}">{{ cl.overUnder ? cl.overUnder.toCurrency() : '' }}</td>
					</tr>

					<tr v-if="hours > 0" v-for="(hours,hourType) in cl.hrsToDate" class="hour-type-row">
						<td><!-- Empty --></td>
						<td>&nbsp; &nbsp; {{ hourTypeLabelMap[hourType] }}</td>
						<td></td>
						<td class="text-right"></td>
						<td class="text-right">{{ hours }}</td>
						<td class="text-right"></td>
						<td class="text-right"></td>
						<td></td>
						<td class="text-right"></td>
					</tr>
				</template>
			</template>
		</tbody>
	</table>
</template>

<script type="text/javascript">
export default {
	name: "LabourReportTable",
	props: ["value"],
	data() {
		return {
			reportLocal: null,
			hourTypeLabelMap: {
				regular_hours: "Reg",
				overtime_hours_15x: "1.5x OT",
				overtime_hours_2x: "2x OT",
				overtime_hours_25x: "2.5x OT"
			}
		}
	},
	watch: {
		value() {
			this.reportLocal = this.value
		}
	},
	created() {
		this.reportLocal = this.value
	}
}
</script>


<style scoped>
	.charge-out-group-row {
		font-weight: 600;
		background-color: #1a1a1a26;
	}

	.hour-type-row {
		font-size: 0.9em;
	}
</style>